import axios from 'axios';
import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { FaUserAstronaut } from 'react-icons/fa6';
import Loading from '../../../components/Loading/Loading';
import Meetings from '../../../components/Meeting/List/Cards/Meetings';
import MeetingModal from '../../../components/Meeting/List/Modals/Meeting';
import Main from '../../../layouts/Main/Main';
import { IMeeting } from '../../../types';

import { IconWrapper } from '../../../components/IconWrapper/IconWrapper';
import styles from './List.module.scss';

const List = () => {
  const [loading, setLoading] = useState<boolean>(true);
  const [showAddMeeting, setShowAddMeeting] = useState<boolean>(false);
  const [meetings, setMeetings] = useState<IMeeting[]>([]);

  useEffect(() => {
    getMeetings();
  }, []);

  const handleAddMeetingModalShow = () => setShowAddMeeting(true);
  const handleAddMeetingModalClose = () => {
    setShowAddMeeting(false);
    getMeetings();
  };

  const breadcrumb = [
    { name: 'Home', path: '/' },
    { name: 'Memberships', path: '/membership', active: true },
  ];

  const actions = (
    <>
      <Button variant="primary" onClick={handleAddMeetingModalShow} size="sm">
        <IconWrapper icon={FaUserAstronaut} /> Add membership
      </Button>
    </>
  );

  const getMeetings = () => {
    setLoading(true);
    axios
      .get('/api/meeting')
      .then((response) => {
        if (response.status === 200) {
          setMeetings(response.data);
        }
      })
      .finally(() => {
        setTimeout(() => setLoading(false), 250);
      });
  };

  return (
    <Main breadcrumb={breadcrumb} actions={actions}>
      <>
        <Container className="mt-3">
          <Loading isLoading={loading}>
            <Row className={styles.List}>
              <Col>
                <Meetings meetings={meetings} />
              </Col>
            </Row>
          </Loading>
        </Container>
        <MeetingModal show={showAddMeeting} onClose={handleAddMeetingModalClose} />
      </>
    </Main>
  );
};

export default List;
